<template>
    <div class="mx-0  pa-0">
        <v-row class="mx-0 mb-0 ">
            <app-crumps :crumps="crumps"></app-crumps>
        </v-row>
        <v-row v-if="seminar" class="mx-0 mb-1">
            <v-col class=" ma-0 px-1 py-0" cols="12">
                <app-seminar-info :bo="bo" :item="seminar" :detail="detail"></app-seminar-info>
            </v-col>
        </v-row>
        <v-row v-else class="mx-0 mb-1">
            You do not have permission to change this seminar.
        </v-row>
        <v-row v-if="seminar" class="mx-0 my-n2 ">
            <v-col class=" ma-0 px-1 py-0 " cols="12">
                <app-programme :bo="bo"></app-programme>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

import seminarInfo from './SeminarInfo.vue';
import programme from './Programme.vue';
import CrumpsVue from '../../sharing/Crumps.vue';


export default {
    props: {
        bo: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            detail: true,
            crumps: [],
            id: null,
            seminar: null,
            wordskeys:"",
        }
    },
    components: {
        AppSeminarInfo: seminarInfo,
        AppProgramme: programme,
        AppCrumps: CrumpsVue,
    },

    created() {

        this.setCategoryId(this.$route.params.id);
        try {
            this.retrieveSeminar({ id: this.$route.params.id, bo: this.bo }).then(() => {
                this.seminar = this.getSeminar(this.$route.params.id);
                this.crumps.push({
                    text: this.seminar.name_short,
                    disabled: true,
                    href: { name: 'seminar.bo', params: { id: this.seminar.id } }
                });
            });
        } catch(error) {
            console.error(error);
            this.seminar = null;
        }
        this.crumps.push({
            text: this.bo ? "dashboard" : "home.title",
            disabled: false,
            href: this.bo ? "dashboardlist" : 'home',
        });
        this.crumps.push({
            text: "events.seminars",
            disabled: false,
            href: this.bo ? 'seminars.bo' : 'seminars',
        });

    },
    computed: {
        ...mapGetters('header', {
            language: 'language',
            smAndDown: 'smAndDown'
        }),
        ...mapGetters('talks', {
            category_id: 'category_id',
            year: 'year',
        }),
        ...mapGetters('seminars', ['getSeminar']),
    },
    methods: {
        ...mapActions('talks', {
            setCategoryId: 'setCategoryId',
        }),
        ...mapActions('seminars', ['retrieveSeminar'])
    }
}
</script>

